import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './HeaderLayout.scss';

function LeftHeaderLayout({children, className}) {
  return <div className={classNames('header-layout-left', className)}>{children}</div>;
}

function CenterHeaderLayout({children, className}) {
  return <div className={classNames('header-layout-center', className)}>{children}</div>;
}

function RightHeaderLayout({children, className}) {
  return <div className={classNames('header-layout-right override-bootstrap-iso', className)}>{children}</div>;
}

function HeaderLayout({children, className}) {
  return <div className={classNames('header-layout', className)}>{children}</div>;
}
LeftHeaderLayout.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
};
LeftHeaderLayout.defaultProps = {
  className: '',
};

CenterHeaderLayout.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
};
CenterHeaderLayout.defaultProps = {
  className: '',
};

RightHeaderLayout.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
};
RightHeaderLayout.defaultProps = {
  className: '',
};

HeaderLayout.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
};
HeaderLayout.defaultProps = {
  className: '',
};

HeaderLayout.Left = LeftHeaderLayout;
HeaderLayout.Center = CenterHeaderLayout;
HeaderLayout.Right = RightHeaderLayout;

export default HeaderLayout;
